export default __webpack_public_path__ + "static/media/sticker-5.32a43bf2.png";